export default {
  props: {
    value: {
      type: Number,
    },
  },
  data() {
    return {
      isNewValueGreater: false,
    };
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        this.isNewValueGreater = newValue > oldValue;
      },
      deep: false,
    },
  },
  computed: {
    transitionName() {
      return this.isNewValueGreater ?
        'animated-number--high' :
        'animated-number--low';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/animated-number/animated-number.js